import { AUTOFACET_CLEAR_ALL, AUTOFACET_REMOVE_FILTER, AUTOFACET_RESET, type RECEIVE_SEARCH_RESPONSE } from 'constants/reduxActions';
import { extractFacetGroup } from 'helpers/AutofacetUtils';
import { GENDER_FACET } from 'helpers/SearchUtils';
import type { BreadcrumbType } from 'types/search';

export interface AutofacetState {
  hasRemovedGender: boolean;
  hasRemovedOtherAutofacet: boolean;
}

const initialState: AutofacetState = {
  hasRemovedGender: false,
  hasRemovedOtherAutofacet: false
};

type AutofacetAction =
  | { type: typeof RECEIVE_SEARCH_RESPONSE; response: { breadcrumbs?: BreadcrumbType[] } }
  | { type: typeof AUTOFACET_REMOVE_FILTER; breadcrumb: BreadcrumbType }
  | { type: typeof AUTOFACET_CLEAR_ALL; breadcrumbs: BreadcrumbType[] }
  | { type: typeof AUTOFACET_RESET };

export default function autofacet(state = initialState, action: AutofacetAction): AutofacetState {
  switch (action.type) {
    case AUTOFACET_REMOVE_FILTER: {
      if (!action.breadcrumb.autoFaceted) {
        return state;
      }

      const facetGroup = extractFacetGroup(action.breadcrumb.removeName);
      const isGender = facetGroup === GENDER_FACET;

      return {
        hasRemovedGender: state.hasRemovedGender || isGender,
        hasRemovedOtherAutofacet: state.hasRemovedOtherAutofacet || !isGender
      };
    }

    case AUTOFACET_CLEAR_ALL: {
      const hasAutoFaceted = action.breadcrumbs.some(c => c.autoFaceted);

      if (!hasAutoFaceted) {
        return state;
      }

      const hasGender = action.breadcrumbs.some(c => c.autoFaceted && extractFacetGroup(c.removeName) === GENDER_FACET);
      const hasOther = action.breadcrumbs.some(c => c.autoFaceted && extractFacetGroup(c.removeName) !== GENDER_FACET);

      return {
        hasRemovedGender: hasGender || state.hasRemovedGender,
        hasRemovedOtherAutofacet: hasOther || state.hasRemovedOtherAutofacet
      };
    }

    case AUTOFACET_RESET:
      return initialState;

    default:
      return state;
  }
}
